import { PATHNAMES } from "src/constants/routes";
import { SECTION_IDS } from "src/page-components/home/constants";
import { addHash, createHashPath } from "src/utils/hash";
import { ReactComponent as PhoneIcon } from "src/assets/icons/phone.svg";
import { ReactComponent as MailIcon } from "src/assets/icons/mail.svg";
import { ReactComponent as Facebookcon } from "src/assets/icons/facebook.svg";
import { ReactComponent as MarkerIcon } from "src/assets/icons/marker.svg";
import { ReactComponent as StarIcon } from "src/assets/icons/star.svg";
import { ReactComponent as StarWayIcon } from "src/assets/icons/star-way-icon.svg";
import { IFooterLink } from "./types";

export const FOOTER_LINKS: IFooterLink[] = [
  {
    id: 1,
    links: [
      {
        id: 1,
        label: "Про нас",
        href: createHashPath(SECTION_IDS.ABOUT_US),
        selector: addHash(SECTION_IDS.ABOUT_US),
      },
      {
        id: 2,
        label: "Послуги",
        href: createHashPath(SECTION_IDS.SERVICES),
        selector: addHash(SECTION_IDS.SERVICES),
      },
      {
        id: 3,
        label: "Пакети",
        href: createHashPath(SECTION_IDS.SERVICE_PACKAGES),
        selector: addHash(SECTION_IDS.SERVICE_PACKAGES),
      },
    ],
  },
  {
    id: 2,
    links: [
      {
        id: 1,
        label: "Калькулятор",
        href: PATHNAMES.CALCULATOR,
      },
      {
        id: 2,
        label: "Наша команда",
        href: createHashPath(SECTION_IDS.TEAM),
        selector: addHash(SECTION_IDS.TEAM),
      },
      {
        id: 3,
        label: "Блог",
        href: PATHNAMES.BLOG,
      },
    ],
  },
  {
    id: 3,
    links: [
      {
        id: 1,
        label: "+38 (067) 353 14 00",
        href: "tel:+380673531400",
        icon: PhoneIcon,
      },
      {
        id: 2,
        label: "ubr161012@gmail.com",
        href: "mailto:ubr161012@gmail.com",
        icon: MailIcon,
      },
      {
        id: 3,
        label: "ubr.ternopil",
        href: "https://www.facebook.com/ubr.ternopil",
        icon: Facebookcon,
        isOpenNewTab: true,
      },
    ],
  },
  {
    id: 4,
    links: [
      {
        id: 1,
        label:
          "вул. Миколи Гоголя, 5 (3 поверх)<br /> м. Тернопіль,<br /> 46001 Україна",
        href: "https://www.google.com/maps/search/%D0%B2%D1%83%D0%BB.+%D0%9C%D0%B8%D0%BA%D0%BE%D0%BB%D0%B8+%D0%93%D0%BE%D0%B3%D0%BE%D0%BB%D1%8F,+5+%D0%BC.+%D0%A2%D0%B5%D1%80%D0%BD%D0%BE%D0%BF%D1%96%D0%BB%D1%8C,+46001+%D0%A3%D0%BA%D1%80%D0%B0%D1%97%D0%BD%D0%B0/@49.5506626,25.5970939,17z/data=!3m1!4b1?entry=ttu&g_ep=EgoyMDI0MDkyNS4wIKXMDSoASAFQAw%3D%3D",
        icon: MarkerIcon,
        isOpenNewTab: true,
      },
      {
        id: 2,
        label:
          "вул. Томашевського, 6/1 м. Львів, Україна",
        href: "https://maps.app.goo.gl/wt3dgHAUe5kDccYR9",
        icon: MarkerIcon,
        isOpenNewTab: true,
      },
      {
        id: 3,
        label:
          "Ми створюємо прості рішення для<br /> складних викликів вашого бізнесу.",
        href: PATHNAMES.HOME,
        icon: StarIcon,
      },
      {
        id: 4,
        label: "Created by Starway",
        href: "https://starway.agency/",
        icon: StarWayIcon,
        isOpenNewTab: true,
      },
    ],
  },
];
